import React, { useEffect, useState } from 'react'
import Authentication from '../../Common/Authentication'
import CreateCustomer from './CreateCustomer'
import { permissions } from '../../Common/Authentication'
import Restricted from '../../Common/Restricted'
import { Spinner } from '@amzn/awsui-components-react'

const CreateCustomerPage = () => {
  const [permissionSet, setPermissionSet] = useState<any>(undefined)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function getPermissionSet() {
      const data = await Authentication()
      setPermissionSet(data)
      setLoading(false)
    }
    getPermissionSet()
  }, [])

  if (loading) {
    return (
      <div className="awsui-util-container awsui-util-t-c">
        <Spinner />
      </div>
    )
  } else {
    if (
      permissionSet &&
      (permissionSet.includes(permissions.CREATE_CUSTOMER) ||
        permissionSet.includes(permissions.PRIVILEGED_ACCESS))
    )
      return (
        <div className="awsui-grid awsui-util-p-m">
          <h1>Create Customer</h1>
          <CreateCustomer />
        </div>
      )
    else {
      return Restricted()
    }
  }
}

export default CreateCustomerPage
